import React from 'react';

export function shiftCalendarDate(value, days) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
  if (!match) return value;
  const shifted = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]) + days, 12);
  const year = shifted.getFullYear();
  const month = String(shifted.getMonth() + 1).padStart(2, '0');
  const day = String(shifted.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export default function DateDayNavigator({ id, value, onChange, label = 'Select Date:' }) {
  return (
    <div className="date-day-navigator">
      <label htmlFor={id}>{label}</label>
      <button
        type="button"
        className="date-day-navigator__button"
        aria-label="Previous day"
        title="Previous day"
        onClick={() => onChange(shiftCalendarDate(value, -1))}
      >
        &#8249;
      </button>
      <input id={id} type="date" value={value} onChange={event => onChange(event.target.value)} />
      <button
        type="button"
        className="date-day-navigator__button"
        aria-label="Next day"
        title="Next day"
        onClick={() => onChange(shiftCalendarDate(value, 1))}
      >
        &#8250;
      </button>
    </div>
  );
}
